import { useState } from "react";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";

function isValidPhone(phone = "") {
  return /^\+[1-9]\d{5,14}$/.test(phone.trim());
}

export default function CountryPhoneInput({
  value = "",
  onChange,
  required = false,
  placeholder = "Enter phone number",
  className = "",
  inputClassName = "",
  dataTestid,
  "data-testid": dataTestIdProp,
  selectClassName = "",
}) {
  const [hasInteracted, setHasInteracted] = useState(false);
  const resolvedDataTestId = dataTestid || dataTestIdProp;
  const isValid = !required || !value || isValidPhone(value);
  const showInvalidState = required && hasInteracted && !isValid;

  const handleChange = (phone) => {
    setHasInteracted(true);
    onChange?.(phone);
  };

  return (
    <div className={`w-full rounded-md border border-gray-300 bg-white transition-colors focus-within:border-[#538135] focus-within:ring-2 focus-within:ring-[#EAF4E3] ${className}`.trim()}>
      <PhoneInput
        defaultCountry="in"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        className="w-full"
        inputClassName={`min-h-[44px] w-full rounded-md border-0 bg-transparent px-3 py-2 text-sm text-gray-900 placeholder:text-gray-400 focus:outline-none ${inputClassName}`.trim()}
        inputProps={{
          "data-testid": resolvedDataTestId,
          "aria-label": "Phone number",
          "aria-invalid": showInvalidState,
          onBlur: () => setHasInteracted(true),
        }}
        countrySelectorStyleProps={{
          buttonClassName: "h-[44px] border-r border-gray-200 bg-transparent px-3 text-sm text-gray-700 hover:bg-gray-50 focus:outline-none",
          dropdownStyleProps: {
            className: "max-h-64 overflow-auto rounded-md border border-gray-200 bg-white shadow-lg",
          },
        }}
        preferredCountries={["in", "us", "gb", "ae", "sg"]}
      />
    </div>
  );
}
